import { useLocation } from 'react-router-dom';
import ReplicationGuide from '../../components/AboutPageSubPages/ReplicationGuide/ReplicationGuide';
import StepByStepGuide from '../../components/AboutPageSubPages/StepByStepGuideComponent/StepByStepGuide';
import './about.styl';
import BlueGreen from '../../components/BlueGreen/BlueGreen';

function About() {
  const location = useLocation()
  const { selection } = location?.state || {}
  return (
    <div className="about">
      {(!selection || selection === 'stepbystep') && <StepByStepGuide />}
      {selection && selection === 'replication' && <ReplicationGuide />}
      {selection && selection === 'bluegreen' && <BlueGreen />}
    </div>
  )
}

export default About;